import React, { useContext, useEffect, useRef } from 'react'
import './App.scss'
import EventDetailView from './components/EventDetailView'
import EventAgendaView from './components/agenda/EventAgendaView'
import EventRegistrationForm from './components/registration/EventRegistrationForm'
import EventSpeakerView from './components/speaker/EventSpeakterView'
import EventTicketsView from './components/ticket/EventTicketsView'
import { ApplicationContext } from './contexts/ApplicationContext'
import RegistrationConfirmView from './components/confirm/RegistrationConfirmView'
import { useTranslation } from 'react-i18next'

function App() {

  const appRef = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  const { eventView, currentView, setCurrentView, ticketCategory } = useContext(ApplicationContext);

  const viewComponentsMap: Map<string, React.ComponentType> = new Map([
    ['eventViewDetail', EventDetailView],
    ['eventViewAgenda', EventAgendaView],
    ['eventViewSpeaker', EventSpeakerView],
    ['eventViewTickets', EventTicketsView],
    ['eventViewRegistrationForm', EventRegistrationForm],
    ['registrationViewConfirm', RegistrationConfirmView],
  ]);

  let CurrentView: React.ComponentType | undefined = viewComponentsMap.get(currentView);
  
  useEffect(() => {
    if (viewComponentsMap.has(currentView)) {
      CurrentView = viewComponentsMap.get(currentView);
    }
  }, [currentView]);

  useEffect(() => {
    if (eventView !== '' && viewComponentsMap.has(eventView)) {
      setCurrentView(eventView);
    }

    document.addEventListener('click', (e: Event) => {
      const target = e.target as HTMLElement;
      if (appRef.current && !appRef.current.contains(target)) {
        const matchedViewNames = [...target.classList].filter((w) => viewComponentsMap.has(w));
        if (matchedViewNames.length > 1) {
          console.warn('Ambiguous view names for event views found.');
        } else if (matchedViewNames.length === 1) {
          setCurrentView(matchedViewNames[0]);
          e.preventDefault();
        }
      }
    });
  }, []);

  useEffect(() => {
    if (ticketCategory) {
      const lng = ticketCategory.includes('/en') ? 'en' : 'de';
      if (i18n.language !== lng) {
        i18n.changeLanguage(lng);
      }
    }
  }, [ticketCategory, i18n]);

  return (
    <div ref={appRef}>
      {CurrentView ? <CurrentView /> : ''}
    </div>
  )
}

export default App
